/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import ReviewPage from '../components/ReviewPage';
import ReviewsPage from '../components/ReviewsPage';
import ReviewsUserPage from '../components/ReviewsUserPage';
import PostsUserPage from 'flarum/forum/components/PostsUserPage';
import { override } from 'flarum/common/extend';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
import type Tag from 'flarum/tags/common/models/Tag';

export default function () {
	// After js/src/forum/routes.js in flarum/core, and js/src/forum/index.js in flarum/tags.
	app.routes.reviews = { path: '/reviews', component: ReviewsPage };
	app.route.reviews = (q?: string) => app.route('reviews', { q });

	app.routes.reviews_tag = { path: '/reviews/t/:tags', component: ReviewsPage };
	app.route.reviews_tag = (tag: Tag) => app.route('reviews_tag', { tags: tag.slug() });

	app.routes['review'] = { path: '/r/:id', component: ReviewPage };
	app.routes['review.near'] = { path: '/r/:id/:near', component: ReviewPage };

	// Catches review links that were still generated as `/d/`.
	override(DiscussionPage.prototype, 'show', function (original, discussion) {
		if (discussion.isReview() && !(this instanceof ReviewPage)) {
			m.route.set(app.route.discussion(discussion));
		} else {
			original(discussion);
		}
	});

	app.routes.user = {
		path: '/u/:username',
		component: ReviewsUserPage,
	};
	app.routes['user.reviews'] = {
		path: '/u/:username',
		component: ReviewsUserPage,
	};

	app.routes['user.posts'] = {
		path: '/u/:username/posts',
		component: PostsUserPage,
	};

	/**
	 * Routes a review to `/r/` and everything else to core's `/d/`.
	 *
	 * CORE_CODE_OVERRIDE
	 */
	app.route.discussion = (discussion, near) => {
		const type = discussion.isReview() ? 'review' : 'discussion';
		return app.route(near && near !== 1 ? `${type}.near` : type, {
			id: discussion.slug(),
			near: near && near !== 1 ? near : undefined,
		});
	};
}
